export default {
  drinks: "BOISSONS",
  food: "ALIMENTS",
  dessert: "LE DESSERT",
  first: "Première",
  second: "Second",
  mainCourses: "PLATS PRINCIPAUX",
  comments: "commentaires:",
  invoice: "Facture d'achat",
  cookies: "Cookies",
  privacy: "Intimité",
  termsAndConditions: "Termes et conditions",
  noRecordMessage:
    "Aucun résultat trouvé. S'il vous plaît, vérifiez les filtres de recherche!",
  askFor: "Demander",
  keep: "Garder",
  close: "Fermer",
  everything: "Tout",
  done: "Terminé",
  toShare: "PARTAGER",
  companyName: "Nom de la compagnie",
  postalCode: "code postal",
  town: "Ville",
  address: "Adresse",
  nameIsRequired: "Le nom est requis",
  addressIsRequired: "L'adresse est requise",
  NIFIsRequired: "NIF est requis",
  postalCodeIsRequired: "Le code postal est requis",
  cityIsRequired: "La ville est obligatoire",
  emailIsRequired: "L'e-mail est requis",
  theEmailMustBeValid: "L'email doit être valide",
  charging: "Mise en charge..."
};
